import React, { useState } from "react";
import {
  ComplianceTypeEntity,
  MasterComplianceCalendarEntity,
} from "../../domain/entities";
import { CalendarEntriesTable } from "./CalendarEntriesTable";
import { Button } from "../../../../ui/components/Button";
import { Badge } from "../../../../ui/components/Badge";
import {
  FeatherChevronDown,
  FeatherChevronUp,
  FeatherPlus,
} from "@subframe/core";

interface ComplianceTypeCardProps {
  type: ComplianceTypeEntity;
  entries: MasterComplianceCalendarEntity[];
  onAddEntry: (complianceTypeId: number) => void;
  onEditEntry: (entry: MasterComplianceCalendarEntity) => void;
  onDeleteEntry: (entryId: number) => void;
  deletingEntryId?: number | null;
}

export const ComplianceTypeCard: React.FC<ComplianceTypeCardProps> = ({
  type,
  entries,
  onAddEntry,
  onEditEntry,
  onDeleteEntry,
  deletingEntryId,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="flex w-full flex-col items-start gap-4 p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
      {/* Card Header */}
      <div className="flex w-full items-center justify-between">
        <div className="flex items-center gap-4">
          <Button
            variant="neutral-tertiary"
            size="small"
            icon={isExpanded ? <FeatherChevronUp /> : <FeatherChevronDown />}
            onClick={() => setIsExpanded(!isExpanded)}
          />
          <div className="flex flex-col items-start gap-1">
            <div className="flex items-center gap-2">
              <span className="text-heading-3 font-heading-3 text-default-font">
                {type.compliance_name}
              </span>
              <Badge variant={type.is_active ? "success" : "error"}>
                {type.is_active ? "Active" : "Inactive"}
              </Badge>
            </div>
            <div className="flex items-center gap-4 text-body font-body text-subtext-color">
              <span>Type: {type.compliance_type}</span>
              <span>Authority: {type.authority}</span>
              <span>Frequency: {type.frequency}</span>
            </div>
          </div>
        </div>
        <Button
          variant="brand-primary"
          size="small"
          icon={<FeatherPlus />}
          onClick={() => onAddEntry(type.id)}
        >
          Add Entry
        </Button>
      </div>

      {/* Card Body - Table */}
      {isExpanded && (
        <div className="w-full">
          <CalendarEntriesTable
            entries={entries}
            onEdit={onEditEntry}
            onDelete={onDeleteEntry}
            deletingEntryId={deletingEntryId}
          />
        </div>
      )}
    </div>
  );
};
